import i18next from "i18next";
import HttpBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const apiKey = "ZtDAiI5UjUvBeO7vUWy8Gw";
const loadPath = `https://api.i18nexus.com/project_resources/translations/{{lng}}/{{ns}}.json?api_key=${apiKey}`;

i18next
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: ["uz", "ru", "en"],
    detection: {
      caches: ["localStorage", "cookie"],
      excludeCacheFor: ["cimode"],
    },
    lng: "uz",
    ns: ["default"],
    defaultNS: "default",
    supportedLngs: ["uz", "ru", "en"],
    backend: {
      loadPath: loadPath,
    },
  });

export default i18next;
